import styled from "styled-components";
import { Info } from "lucide-react";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e9eaeb;
  border-radius: 12px;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  background: #fff;
  width: 100%;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #ffffff;
  border-bottom: 1px solid #e9eaeb;

  a {
    font-family: "Geist", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: #535862;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
    &:active {
      opacity: 0.6;
    }
  }
`;

export const CardContent = styled.div`
  background: #fff;
  padding: 0; /* ✅ avoid double padding around the Table */
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: "Geist", sans-serif;
`;

export const TableHead = styled.thead`
  background: #f9fafb;
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #e9eaeb;

  &:last-child {
    border-bottom: none; /* ✅ removes extra border at the bottom */
  }
`;

export const TableHeader = styled.th`
  text-align: left;
  padding: 12px 20px;
  font-size: 12px;
  font-weight: 600;
  color: #717680;
`;

export const TableCell = styled.td`
  padding: 16px 20px;
  font-size: 14px;
  color: #414651;
`;

export const AssetCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AssetLogo = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
`;

export const TitleInfoIcon = styled(Info)`
  display: inline-block;
  vertical-align: -2px;
  margin-left: 6px;
  opacity: 0.6;
  cursor: help;
`;

export const TooltipText = styled.span`
  display: block;
  max-width: 260px;

  & + & {
    margin-top: 8px;
  }
`;
